// Valores dos enums do banco (espelham o schema Prisma) e os rótulos exibidos na interface.

export const PERFIS = ["ADMIN", "OPERADOR"] as const;
export type Perfil = (typeof PERFIS)[number];
export const PERFIL_ROTULO: Record<Perfil, string> = {
  ADMIN: "Administrador",
  OPERADOR: "Operador",
};

export const STATUS_EVENTO = ["PLANEJADO", "EM_ANDAMENTO", "ENCERRADO"] as const;
export type StatusEvento = (typeof STATUS_EVENTO)[number];
export const STATUS_EVENTO_ROTULO: Record<StatusEvento, string> = {
  PLANEJADO: "Planejado",
  EM_ANDAMENTO: "Em andamento",
  ENCERRADO: "Encerrado",
};

export const TIPOS_MOVIMENTACAO = ["ENTRADA", "VENDA", "CANCELAMENTO", "AJUSTE", "PERDA", "OFERTA"] as const;
export type TipoMovimentacao = (typeof TIPOS_MOVIMENTACAO)[number];
/** Tipos que o ADMIN lança à mão; VENDA e CANCELAMENTO só o sistema gera, e OFERTA tem tela própria. */
export const TIPOS_MOVIMENTACAO_MANUAL = ["ENTRADA", "AJUSTE", "PERDA"] as const;
export type TipoMovimentacaoManual = (typeof TIPOS_MOVIMENTACAO_MANUAL)[number];
export const TIPO_MOVIMENTACAO_ROTULO: Record<TipoMovimentacao, string> = {
  ENTRADA: "Entrada",
  VENDA: "Venda",
  CANCELAMENTO: "Cancelamento",
  AJUSTE: "Ajuste",
  PERDA: "Perda",
  OFERTA: "Oferta",
};

export const FORMAS_PAGAMENTO = ["DINHEIRO", "PIX", "DEBITO", "CREDITO"] as const;
export type FormaPagamento = (typeof FORMAS_PAGAMENTO)[number];
export const FORMA_PAGAMENTO_ROTULO: Record<FormaPagamento, string> = {
  DINHEIRO: "Dinheiro",
  PIX: "Pix",
  DEBITO: "Débito",
  CREDITO: "Crédito",
};

export const STATUS_CAIXA = ["ABERTO", "FECHADO"] as const;
export type StatusCaixa = (typeof STATUS_CAIXA)[number];

export const STATUS_VENDA = ["VALIDA", "CANCELADA"] as const;
export type StatusVenda = (typeof STATUS_VENDA)[number];
export const STATUS_VENDA_ROTULO: Record<StatusVenda, string> = {
  VALIDA: "Válida",
  CANCELADA: "Cancelada",
};

export const SENHA_MINIMA = 10;

/** PIN de autorização do ADMIN: só números, de 4 a 6 dígitos. */
export const PIN_MINIMO = 4;
export const PIN_MAXIMO = 6;

export const ACAO_AUDITORIA_ROTULO = {
  LOGIN: "Login",
  LOGIN_FALHA: "Falha de login",
  LOGOUT: "Logout",
  SENHA_ALTERADA: "Senha alterada",
  USUARIO_CRIADO: "Usuário criado",
  USUARIO_EDITADO: "Usuário editado",
  USUARIO_DESATIVADO: "Usuário desativado",
  USUARIO_REATIVADO: "Usuário reativado",
  USUARIO_SENHA_REDEFINIDA: "Senha redefinida",
  EVENTO_CRIADO: "Evento criado",
  EVENTO_EDITADO: "Evento editado",
  EVENTO_STATUS_ALTERADO: "Status do evento",
  EVENTO_EXCLUIDO: "Evento excluído",
  EVENTO_CARDAPIO_ALTERADO: "Cardápio alterado",
  CATEGORIA_CRIADA: "Categoria criada",
  CATEGORIA_EDITADA: "Categoria editada",
  CATEGORIA_EXCLUIDA: "Categoria excluída",
  PRODUTO_CRIADO: "Produto criado",
  PRODUTO_EDITADO: "Produto editado",
  PRODUTO_EXCLUIDO: "Produto excluído",
  PRODUTO_ARQUIVADO: "Produto arquivado",
  ESTOQUE_MOVIMENTACAO: "Movimentação de estoque",
  CAIXA_ABERTO: "Caixa aberto",
  CAIXA_FECHADO: "Caixa fechado",
  CAIXA_REABERTO: "Caixa reaberto",
  VENDA_CANCELADA: "Venda cancelada",
  VENDA_DIVERGENCIA_AUTORIZADA: "Venda offline autorizada",
  AUTORIZACAO_ADMIN_FALHA: "Falha de autorização de ADMIN",
  RELATORIO_EXPORTADO: "Relatório exportado",
  IMPORTACAO_PROTOTIPO: "Importação do protótipo",
  VENDA_AJUSTADA: "Venda ajustada",
  FECHAMENTO_RECALCULADO: "Fechamento recalculado",
  PIN_ALTERADO: "PIN alterado",
  OFERTA_REGISTRADA: "Oferta registrada",
  OFERTA_CANCELADA: "Oferta cancelada",
} as const;
export type AcaoAuditoria = keyof typeof ACAO_AUDITORIA_ROTULO;
export const ACOES_AUDITORIA = Object.keys(ACAO_AUDITORIA_ROTULO) as AcaoAuditoria[];
